export class GroupsMembersParams {
  ids?: number[];
  groupeIds?: number[];
  contactIds?: number[];
  sortFields?: string;
  sortOrder?: string;
  pageNumber?: number;
  pageSize?: number;
}
